import script from "./_filter-checkboxes.vue?vue&type=script&setup=true&lang=js"
export * from "./_filter-checkboxes.vue?vue&type=script&setup=true&lang=js"

import "./_filter-checkboxes.vue?vue&type=style&index=0&id=44f77e53&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f77e53"]])

export default __exports__